<template>
  <com-header title="登录">
    <div class="login">
      <header></header>
      <div class="content">
        <!-- 表单账号登录 start-->
        <van-form @submit="submitByUserName" ref="refuser" v-show="loginMode === 1">
          <van-field v-model="userForm.userAccount" clearable name="用户名" placeholder="用户名/手机号" :rules="[{ required: true, message: '请填写用户名/手机号' }]" />
          <van-field v-model="userForm.userPwd" clearable type="password" name="密码" placeholder="密码" :rules="[{ required: true, message: '请填写密码' }]" />
          <div style="padding: 16px">
            <van-button round block type="info" native-type="submit">登录</van-button>
          </div>
          <div class="other">
            <span @click="changeLoginType(2)"><i class="phone iconfont icon-shoujidenglu" />手机登录</span>
          </div>
        </van-form>
        <!-- 表单账号登录 end -->

        <!-- 表单手机登录 start-->
        <van-form @submit="submitByMobile" ref="refmobile" v-show="loginMode === 2">
          <van-field v-model="mobileForm.mobile" clearable name="手机号" type="tel" placeholder="手机号" :rules="[{ validator: checkPhone, message: '' }]" />
          <van-field v-model="mobileForm.verCode" clearable type="number" name="验证码" placeholder="验证码" :rules="[{ required: true, message: '请填写验证码' }]">
            <template #button>
              <van-button size="small" type="primary" :disabled="downTime > 0" native-type="button" @click="sendCode">{{
                  downTime > 0 ? downTime + "秒后重发" : "发送验证码"
                }}</van-button>
            </template>
          </van-field>
          <div style="padding: 16px">
            <van-button round block type="info" native-type="submit">登录</van-button>
          </div>
          <div class="other">
            <span @click="changeLoginType(1)"><i class="user iconfont icon-denglu-zhanghudenglu" />账户登录</span>
          </div>
        </van-form>
        <!-- 表单手机登录 end -->
      </div>
    </div>
  </com-header>
</template>

<script>
import ComHeader from "./components/comHeader";
import {
  LoginByUsername,
  LoginByMobile,
  GetLoginVerCode,
} from "@/pages/page1/api-work/index";
import { Button, Form, Field, Toast } from "vant";
import { validMobile } from "@/pages/publicUtils/validate";
export default {
  metaInfo: { title: "欢迎登录" },
  components: {
    ComHeader,
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [Toast.name]: Toast,
  },
  data() {
    return {
      userForm: {
        userAccount: "",
        userPwd: "",
        clientType: 5, //pc=0 小程序=1 h5=5 pc_shop=6
        loginType: 2, //平台_商家_C端 = 0,平台_商家 = 1,商家 = 2 C端 = 3,
      },
      mobileForm: {
        mobile: "",
        verCode: "",
        clientType: 5, //pc=0 小程序=1 h5=5 pc_shop=6
        loginType: 2,
      },
      loginMode: 1, //1账户 2手机
      downTime: 0,
    };
  },
  mounted() {
    // 默认工单首页，如果是首页客户签收 类型为C端 = 3
    if (!localStorage.getItem("H5HOME")) return;
    let path1 = localStorage.getItem("H5HOME").toLowerCase();
    let path2 = "/signGoods".toLowerCase();
    if (path1.indexOf(path2) !== -1) {
      this.userForm.loginType = 3;
      this.mobileForm.loginType = 3;
    }
  },
  methods: {
    submitByUserName() {
      LoginByUsername(this.userForm).then((res) => {
        this.loginRes(res);
      });
    },
    submitByMobile() {
      LoginByMobile(this.mobileForm).then((res) => {
        this.loginRes(res);
      });
    },
    loginRes(res) {
      // console.log("登录返回结果", res);
      let data = res.data[0];
      localStorage.setItem("WORK_ATOKEN", data.accessToken);
      localStorage.setItem("WORK_RTOKEN", data.refreshToken);
      this.$router.push(localStorage.getItem("H5HOME") || "/workOrder");
    },
    changeLoginType(type) {
      this.loginMode = type;
      Toast.clear();
      this.$refs.refuser.resetValidation();
      this.$refs.refmobile.resetValidation();
      this.userForm.userAccount = "";
      this.userForm.userPwd = "";
      this.mobileForm.mobile = "";
      this.mobileForm.verCode = "";
    },
    sendCode() {
      this.$refs.refmobile.validate("手机号").then(() => {
        GetLoginVerCode({ mobile: this.mobileForm.mobile }).then((res) => {
          // console.log("获取到的验证码", res);
          this.mobileForm.verCode = res.data[0].verCode;
          this.downTime = 60;
          let aTime = setInterval(() => {
            this.downTime -= 1;
            if (this.downTime <= 0) {
              clearInterval(aTime);
            }
          }, 1000);
        });
      });
    },
    // 验证
    checkPhone(val) {
      if (!val) {
        Toast("请填写手机号");
        return false;
      }
      if (!validMobile(val)) {
        Toast("手机号格式不对");
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.login {
  header {
    background: url("~@/assets/img/LGBanner.jpg") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: 5.2rem;
    position: relative;
    top: -0.8rem;
  }
  .content {
    margin: 0 0.3rem;
    border-radius: 0.3rem;
    position: relative;
    top: -1.2rem;
    z-index: 2;

    background: #fff;
    box-sizing: border-box;
    padding: 0.4rem 0;
    /deep/ .van-form {
      padding: 0 0.2rem;
      padding-bottom: 0.8rem;
      .van-cell {
        overflow: visible;
        .van-cell__value {
          position: static;
          .van-field__error-message {
            position: absolute;
            top: 100%;
            left: 16px;
          }
        }
      }
      .van-field--error {
        margin-bottom: 24px;
        .van-field__body {
          .van-field__control::placeholder {
            color: #969799;
          }
        }
      }
      .other {
        margin-top: 0.2rem;
        text-align: right;
        color: @themeColor;
        .phone {
          color: #ea6b65;
          padding-right: 0.1rem;
        }
        .user {
          color: #2899fb;
          padding-right: 0.1rem;
        }
      }
    }
  }
}
</style>